// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reminderSelect[data-v-9f4d057c]{margin-top:15px;padding-top:15px;border-top:1px solid #e5e5e5}.sendOptions .fields[data-v-9f4d057c]{display:grid;grid-template-columns:1fr 1fr 1fr;-webkit-column-gap:5px;-moz-column-gap:5px;column-gap:5px}", ""]);
// Exports
module.exports = exports;
